export { default } from './StepTitle';
